<template>
  <v-container class="transparent" fluid>
    <bread-crumb :breadcrumb-data="breadcrumbData"></bread-crumb>
    <v-sheet class="pa-2" rounded min-height="600">

      <v-row>
        <v-col cols="2">
          <v-list-item @click="loadData('basicInfo')">
            <v-list-item-icon>
              <v-icon>mdi-information-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title :class="selectedTab === 'basicInfo' ? 'font-weight-bold' : ''">
              Basic information
            </v-list-item-title>
          </v-list-item>

          <v-list-group color="black" prepend-icon="mdi-view-grid" value="true">
            <template v-slot:activator>
              <v-list-item-title>Detailed information</v-list-item-title>
            </template>
            <v-list-item v-if="result_data.summary?.text_evidence > 0">
              <v-list-item-title :class="selectedTab === 'text_mining' ? 'font-weight-bold' : ''"
                                 @click="loadData('text_mining')">
                &nbsp;&nbsp;&nbsp;&nbsp;<v-icon>mdi-book-search-outline</v-icon>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Text mining
              </v-list-item-title>
            </v-list-item>
            <v-list-item v-if="result_data.summary?.figure_evidence > 0">

              <v-list-item-title :class="selectedTab === 'figure' ? 'font-weight-bold' : ''"
                                 @click="loadData('figure')">
                &nbsp;&nbsp;&nbsp;&nbsp;<v-icon>mdi-picture-in-picture-top-right</v-icon>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Figure mining
              </v-list-item-title>
            </v-list-item>

            <v-list-item v-if="result_data.network_available">

              <v-list-item-title :class="selectedTab === 'network' ? 'font-weight-bold' : ''"
                                 @click="loadData('network')">
                &nbsp;&nbsp;&nbsp;&nbsp;<v-icon>mdi-graphql</v-icon>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Network
              </v-list-item-title>
            </v-list-item>

            <v-list-item>
              <v-list-group color="black" prepend-icon="mdi-zodiac-cancer" value="true">
                <template v-slot:activator>
                  <v-list-item-title>CPTAC datasets</v-list-item-title>
                </template>

                <v-list-item >
                  <v-list-item-title :class="selectedTab === 'cptac_abundance' ? 'font-weight-bold' : ''"
                                     @click="loadData( 'cptac_abundance')"  >
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<v-icon>mdi-chart-bar</v-icon>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Tumor vs Normal
                  </v-list-item-title>
                </v-list-item>
                <v-list-item v-if="result_data.summary.cohort > 0">
                  <v-list-item-title :class="selectedTab === 'cptac_phenotype' ? 'font-weight-bold' : ''"
                                     @click="loadData( 'cptac_phenotype')" v-if="result_data.summary.cohort > 0">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<v-icon>mdi-chart-bubble</v-icon>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Phenotype Association
                  </v-list-item-title>
                </v-list-item>
                <!--                <v-list-item v-if="result_data.phenotype.hallmark && result_data.phenotype.hallmark.length > 0">-->
                <v-list-item v-if="result_data.summary.cohort > 0">
                  <v-list-item-title :class="selectedTab === 'cptac_hallmark' ? 'font-weight-bold' : ''"
                                     @click="loadData('cptac_hallmark')"   v-if="result_data.summary.cohort > 0">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<v-icon>mdi-chart-donut</v-icon>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;MSigDB Hallmark Association
                  </v-list-item-title>
                </v-list-item>
              </v-list-group>
            </v-list-item>


            <v-list-item v-if="result_data.summary?.experiment > 0">

              <v-list-item-title :class="selectedTab === 'experiment' ? 'font-weight-bold' : ''"
                                 @click="loadData('experiment')">
                &nbsp;&nbsp;&nbsp;&nbsp;<v-icon>mdi-data-matrix-plus</v-icon>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;PTMAtlas datasets
              </v-list-item-title>
            </v-list-item>

          </v-list-group>
        </v-col>

        <v-col cols="10">
          <v-sheet min-height="800px" outlined rounded width="100%">
            <v-row v-if="loading" align="center" justify="center" no-gutters>
              <v-progress-circular
                  :rotate="360"
                  :size="100"
                  :value="progressValue"
                  :width="15"
                  class="my-16"
                  color="teal"
              >
                {{ progressValue }}
              </v-progress-circular>
            </v-row>

            <v-row v-else no-gutters>
              <v-col cols="12">
                <!-- Basic Information -->


                <v-sheet v-if="selectedTab === 'basicInfo'" height="100%" width="100%">
                  <v-card-title class="font-weight-bold">Basic Information</v-card-title>

                  <v-row class="pa-1" no-gutters>
                    <v-col cols="8">
                      <v-card-text>
                        <detail-basic-info :tdata="result_data.summary" :hoc="result_data.cancer_hallmark" :disease="result_data.disease" :chemical="result_data.chemical" :cellline="result_data.cellline"  :gene="result_data.gene" :signature='result_data.signature' @switch-tab="loadData"></detail-basic-info>
                      </v-card-text>
                    </v-col>
                    <v-col cols="4">
                      <v-row>
                        <v-col cols="12">
                          <v-sheet>
                            <v-sheet class="font-weight-bold mt-6" style="color: black;font-size: 1.1rem">Structure Viewer:
                              <v-btn style="text-decoration: none" class="label" x-small dark color="blue" @click="openalphafold" >Alphafold <v-icon x-small>mdi-share</v-icon></v-btn>
                              <helpicon tooltip-text="Click to check the detailed information at https://alphafold.ebi.ac.uk/"></helpicon>

                            </v-sheet>
                            <protein-p-t-mview
                                v-if="selectedTab === 'basicInfo'"
                                :visible="true"
                                :pdb-id="result_data.summary.Uniprot"
                                :ptm-residue="result_data.summary.site"
                            />

                          </v-sheet>
                        </v-col>
                      </v-row>
                      <v-row v-show="result_data.wordcloud && result_data.wordcloud.length > 0">
                        <v-col cols="12">
                          <v-sheet>
                            <v-sheet class="font-weight-bold mt-6" style="color: black;font-size: 1.1rem">Word Cloud:
                            </v-sheet>
                            <word-cloud-chart  :tdata="result_data.wordcloud"></word-cloud-chart>
                          </v-sheet>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-sheet>
                <!-- Text Mining -->
                <v-sheet v-show="selectedTab === 'text_mining'" height="100%" width="100%">
                  <v-card-title class="font-weight-bold">Text mining table</v-card-title>
                  <v-card-text>
                    <div>
                      <v-icon color="blue" small>mdi-heart</v-icon>
                      Help
                    </div>
                    <div>
                      PubTator3 is utilized to extract PTM-related entities as well as other biological entities from MEDLINE abstract and full-text articles. <br>
                      <span style="font-weight: bold; color: black">PMID-level </span> and <span style="font-weight: bold; color: black">Sentence-level </span> mode are provided in the table. <br>

                      <span class="legend-title">Annotation Color in Sentence:</span> &nbsp;&nbsp;
                      <span class="legend-items">
                      <span class="legend-item highlight-substrate">Substrate</span> &nbsp;
                      <span class="legend-item highlight-site">Site</span> &nbsp;
                      <span class="legend-item highlight-chemical">Chemical</span> &nbsp;
                      <span class="legend-item highlight-cellline">Cell line</span> &nbsp;
                      <span class="legend-item highlight-disease">Disease</span> &nbsp;
                      <span class="legend-item highlight-gene">Gene</span>
                      </span> <br>
                      Cancerhallmark is predicted for each sentence by using BioLinkBert. <br>
                      Click <span style="font-weight: bold; color: black">Link</span> button to PMC, the involved sentence will be highlighted in the article.


                    </div>
                  </v-card-text>
                  <v-divider></v-divider>

                  <v-sheet class="my-6 mx-2">
                    <detail-text-table :tdata="result_data.text_mining"></detail-text-table>
                  </v-sheet>
                </v-sheet>
                <!-- Figure -->
                <v-sheet v-show="selectedTab === 'figure'" height="100%" width="100%">
                  <v-card-title class="font-weight-bold">Figure table</v-card-title>
                  <v-card-text>
                    <div>
                      <v-icon color="blue" small>mdi-heart</v-icon>
                      Help
                    </div>
                    <div>
                      Pathway Figure OCR (PFOCR) is used to extract relevant entities from pathway figures, enhanced by manual curation. <br>
                      The figure is interactive and can be clicked for detailed information, while the <a href="https://pfocr.wikipathways.org/">PFOCR</a> link provides further resources.<br>
                      The signature name was generated by GPT-4o-mini based on the figure title.

                    </div>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-sheet class="ma-2">
                    <detail-figure-table :tdata="result_data.figure"></detail-figure-table>
                  </v-sheet>
                </v-sheet>

                <!-- network -->
                <v-sheet v-if="selectedTab === 'network'" height="100%" width="100%">
                  <v-card-title class="font-weight-bold">Network</v-card-title>
                  <v-card-text >
                      <div>
                        <v-icon color="blue" small>mdi-heart</v-icon>
                        Help
                      </div>
                      <div>
                        PTMax leverages <a href="https://pubmed.ncbi.nlm.nih.gov/40113755/" class="font-weight-bold">CoPheeMap</a>, a phosphosite co-regulation network learned from CPTAC pan-cancer phosphoproteomics data, to provide network context for individual sites. For a phosphosite, a random-walk expansion identifies a local subnetwork of the top 50 co-regulated sites, which is displayed as an interactive node–link diagram. All sites in the subnetwork can be directly submitted to batch queries to retrieve annotations and perform enrichment analyses.

                      </div>
                    </v-card-text>
                    <v-divider></v-divider>

                  <v-sheet class="pa-2">
                    <NetworkParent :result_data="result_data.network" />
                  </v-sheet>
                </v-sheet>
                <!-- Cancer Abundance Tabs -->
                <v-sheet v-show="selectedTab === 'cptac_abundance'" height="100%" width="100%">
                  <v-card-title class="font-weight-bold">Tumor vs Normal</v-card-title>
                  <v-card-text>
                    <div>
                      <v-icon color="blue" small>mdi-heart</v-icon>
                      Help
                    </div>
                    <div>The abundance data were integrated from <a href="https://kb.linkedomics.org/">LinkedOmicsKB</a>.<br>
                      The <a style="color: #0d47a1;font-weight: bold">phosphosite, RNA, protein</a> abundance for comparison between tumor and normal samples in each cancer cohort is shown separately. <br/>
                    </div>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-sheet class="mt-3" >
                    <v-row>
                      <template v-if="abundanceLoaded">
                        <v-col class="pa-4" cols="12" lg="4" md="12" xl="4">
                          <t-nomics-abundance :image-src="result_data.abundance.phos.image"
                                              :metap="result_data.abundance.phos.metap"
                                              :title="result_data.abundance.phos.title"></t-nomics-abundance>
                        </v-col>

                        <v-col class="pa-4" cols="12" lg="4" md="12" xl="4">
                          <t-nomics-abundance :image-src="result_data.abundance.rna.image"
                                              :metap="result_data.abundance.rna.metap"
                                              :title="result_data.abundance.rna.title"></t-nomics-abundance>
                        </v-col>

                        <v-col class="pa-4" cols="12" lg="4" md="12" xl="4">
                          <t-nomics-abundance :image-src="result_data.abundance.protein.image"
                                              :metap="result_data.abundance.protein.metap"
                                              :title="result_data.abundance.protein.title"></t-nomics-abundance>
                        </v-col>
                      </template>
                      <template v-else>
                        <v-row align="center" justify="center" no-gutters class="my-16">
                          <v-progress-circular indeterminate color="teal" size="70" width="6" />
                        </v-row>
                      </template>
                    </v-row>
                  </v-sheet>
                </v-sheet>
                <v-sheet v-if="selectedTab === 'cptac_phenotype'" height="100%" width="100%">
                  <v-card-title class="font-weight-bold">Phenotype Comparison</v-card-title>

                  <v-card-text>
                    <div>
                      <v-icon color="blue" small>mdi-heart</v-icon>
                      Help
                    </div>
                    <div>
                      The phenotype data were integrated from <a href="https://kb.linkedomics.org/">LinkedOmicsKB</a>.<br>
                      While the Volcano plot reveals significant PTM-phenotype associations, the scatter plots highlights the associations that are independent of mRNA and protein level changes.
                    </div>
                  </v-card-text>
                  <v-divider></v-divider>

                  <v-sheet height="50%" width="100%">

                      <template v-if="result_data.phenotype.phenotype && result_data.phenotype.phenotype.length > 0">
                        <phenotype :tdata="result_data.phenotype.phenotype"></phenotype>
                      </template>
                      <template v-else>
                        <v-sheet class="text-center pa-6">
                          No phenotype data available.
                        </v-sheet>
                      </template>
                  </v-sheet>
                </v-sheet>
<!--                <v-sheet v-if="selectedTab === 'cptac_hallmark'" height="50%" width="100%">-->
<!--                  <v-card-title class="font-weight-bold">MsigDB Hallmark</v-card-title>-->
<!--                  <v-card-text>-->
<!--                    <div>-->
<!--                      <v-icon color="blue" small>mdi-heart</v-icon>-->
<!--                      Help-->
<!--                    </div>-->
<!--                    <div>-->
<!--                      The MSigDB hallmark data were integrated from <a href="https://kb.linkedomics.org/">LinkedOmicsKB</a>.<br>-->
<!--                      The 'PTM-Phenotype Heatmap Across Different Cancer Cohorts' visualizes site-hallmark associates across cancer types.<br>-->
<!--                      The heatmap 'Comparing Phenotype Correlation at Site, RNA, and Protein Levels' highlights significant site-hallmark associations across cancer types (through meta-analysis) that cannot be attributed to associations at mRNA and protein levels.<br>-->
<!--                    </div>-->
<!--                  </v-card-text>-->

<!--                  <v-sheet height="100%" width="100%">-->

<!--                    <template>-->
<!--                      <template v-if="result_data.phenotype.metap && result_data.phenotype.metap.length > 0">-->
<!--                        <v-row >-->
<!--                          <v-col cols="12" class="pr-8">-->
<!--                            <phenotype-hallmark :tdata="result_data.phenotype.hallmark" />-->
<!--                          </v-col>-->
<!--                        </v-row>-->
<!--                        <v-row>-->
<!--                          <v-col cols="12" class="pr-8">-->
<!--                            <phenotype-hallmark-metap :tdata="result_data.phenotype.metap" />-->
<!--                          </v-col>-->
<!--                        </v-row>-->

<!--                      </template>-->

<!--                      <template v-else>-->
<!--                        <v-sheet class="text-center pa-6">-->
<!--                          No hallmark data available.-->
<!--                        </v-sheet>-->
<!--                      </template>-->
<!--                    </template>-->
<!--                  </v-sheet>-->
<!--                </v-sheet>-->
                <v-sheet v-if="selectedTab === 'cptac_hallmark'" height="50%" width="100%">
                  <v-card-title class="font-weight-bold">MsigDB Hallmark</v-card-title>

                  <v-card-text>
                    <div>
                      <v-icon color="blue" small>mdi-heart</v-icon>
                      Help
                    </div>
                    <div>
                      The MSigDB hallmark data were integrated from
                      <a href="https://kb.linkedomics.org/">LinkedOmicsKB</a>.<br>
                      The <a style="font-weight: bold; color: black">Cancer-specific Perspective Tab</a> provides 'PTM-Phenotype Heatmap Across Different Cancer Cohorts', visualizing site-hallmark associates across cancer types.<br>
                      The <a style="font-weight: bold; color: black">Pan-cancer View Tab</a> is using heatmap to illustrate 'Comparing Phenotype Correlation at Site, RNA, and Protein Levels', which highlights significant site-hallmark associations across cancer types (through meta-analysis) that cannot be attributed to associations at mRNA and protein levels.<br>
                    </div>
                  </v-card-text>
                  <v-divider></v-divider>

                  <v-tabs
                      v-model="hallmarkSubTab"
                  >
                    <v-tab style="text-transform: none">
                      Cancer-specific Perspective
                    </v-tab>

                    <v-tab style="text-transform: none">
                      Pan-cancer View
                    </v-tab>
                  </v-tabs>


                  <v-tabs-items v-model="hallmarkSubTab" class="my-8">
                    <v-tab-item>
                      <template v-if="result_data.phenotype.hallmark && result_data.phenotype.hallmark.length > 0">
                        <v-row>
                          <v-col cols="12" class="pr-8">
                            <phenotype-hallmark :tdata="result_data.phenotype.hallmark" />
                          </v-col>
                        </v-row>
                      </template>
                      <v-sheet v-else class="text-center pa-6">
                        No cancer-specific hallmark data available.
                      </v-sheet>
                    </v-tab-item>

                    <!-- Tab 1: pan-cancer -->
                    <v-tab-item >
                      <template v-if="result_data.phenotype.metap && result_data.phenotype.metap.length > 0">
                        <v-row>
                          <v-col cols="12" class="pr-8">
                            <phenotype-hallmark-metap :tdata="result_data.phenotype.metap" />
                          </v-col>
                        </v-row>
                      </template>
                      <v-sheet v-else class="text-center pa-6">
                        No pan-cancer hallmark data available.
                      </v-sheet>
                    </v-tab-item>
                  </v-tabs-items>
                </v-sheet>


                <v-sheet v-show="selectedTab === 'experiment'" height="100%" width="100%">
                  <v-card-title class="font-weight-bold">PTMAtlas datasets</v-card-title>
                  <v-card-text>
                    <div>
                      <v-icon color="blue" small>mdi-heart</v-icon>
                      Help
                    </div>
                    <div>
                      PTMax integrates phosphorylation data from <a href="https://deepmvp.ptmax.org/">PTMAtlas</a>, initially collected 157 phosphoproteomics datasets, of which 110 were integrated into a single meta-dataset (PXD012174), resulting in a total of 48 datasets, covering diverse physiological conditions.
                    </div>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-sheet class="my-6 mx-2">
                    <detail-experiment-table :tdata="result_data.experiment"></detail-experiment-table>
                  </v-sheet>
                </v-sheet>
              </v-col>
            </v-row>
          </v-sheet>
        </v-col>
      </v-row>
    </v-sheet>
  </v-container>
</template>


<script>
import BreadCrumb from "@/components/sub/breadcrumb.vue";
import Axios from "axios";
import detailTextTable from "@/components/DetailTextTable.vue";
import detailBasicInfo from "@/components/DetailBasicInfo.vue";
import detailFigureTable from "@/components/DetailFigureTable.vue";
import DetailExperimentTable from "@/components/DetailExperimentTable.vue";
import Phenotype from '@/components/Phenotype.vue';
import WordCloudChart from "@/components/WordCloudChart.vue";
import ProteinPTMview from "@/components/ProteinPTMview.vue";
import PhenotypeHallmark from "@/components/PhenotypeHallmark.vue";
import PhenotypeHallmarkMetap from "@/components/PhenotypeHallmarkMetap.vue";
import TNomicsAbundance from "@/components/TNomicsAbundance.vue";
import NetworkParent from "@/components/NetworkParent.vue";
import Helpicon from "@/components/sub/helpicon.vue";
import {apiprefix} from "@/main";

export default {
  name: "DetailForSite",
  props: {
    id: {type: String, required: true},
    ptm_type: {type: String}
  },
  components: {
    Helpicon,
    TNomicsAbundance,
    PhenotypeHallmarkMetap,
    PhenotypeHallmark,
    ProteinPTMview,
    NetworkParent,
    WordCloudChart, Phenotype,
    DetailExperimentTable, BreadCrumb, detailTextTable, detailBasicInfo, detailFigureTable
  },
  data() {
    return {

      currentId: this.id,
      currentType: "",
      selectedTab: "basicInfo",
      loading: true,
      progressValue: 0,
      progressTimer: null,
      hallmarkSubTab: 0,
      result_data: {
        text_mining: [],
        summary: {},
        network:{},
        network_available:false,
        cancer_hallmark:[],
        chemical:[],
        disease:[],
        cellline:[],
        figure: [],
        wordcloud: [],
        experiment: [],
        signature:{},
        abundance: {
          phos: {
            'title': "Phosphosite Abundance in Different Cohort"
          },
          rna: {
            "title": 'RNA Abundance in Different Cohort'
          },
          protein: {
            'title': "Protein Abundance in Different Cohort"
          }
        },
        phenotype: {
          phenotype: [],
          metap: [],
          hallmark: []
        }
      },
      // loadedTabs: {
      //   basicInfo: false,
      //   text_mining: false,
      //   figure: false,
      //   experiment: false,
      //   cptac_phenotype: false,
      //   cptac_hallmark: false,
      // },
      abundanceLoaded: false,
    };
  },
  methods: {
    openalphafold(){
      window.open(`https://alphafold.ebi.ac.uk/entry/${this.result_data.summary.Uniprot}`, "_blank");
    },
    fetchInfo() {
      // this.loading = true;
      const token = Symbol('progress');
      this._progressToken = token;

      this.progressValue = 0;
      if (this.progressTimer) clearInterval(this.progressTimer);

      this.progressTimer = setInterval(() => {
        if (this._progressToken !== token) return;
        if (this.progressValue < 90) {
          this.progressValue += 5;
        }
      }, 200);

      return Axios.post(`${apiprefix}/api/detail_persite/`, {}, {
        params: {
          select_id: this.currentId,
          select_type: this.currentType,
        },
      })
          .then((res) => {
            if (res.data && res.data.data) {
              this.result_data.summary = res.data.data.summary || {};
              this.result_data.network_available = res.data.data.network_available || false;
              this.result_data.network = res.data.data.network || {};
              this.result_data.cancer_hallmark = res.data.data.cancer_hallmark || [];
              this.result_data.wordcloud = res.data.data.wordcloud || [];
              this.result_data.text_mining = res.data.data.text_mining || [];
              this.result_data.experiment = res.data.data.experiment || [];
              this.result_data.signature = res.data.data.signature || {};
              this.result_data.figure = res.data.data.figure || [];
              this.result_data.chemical = res.data.data.chemical || [];
              this.result_data.disease = res.data.data.disease || [];
              this.result_data.cellline = res.data.data.cellline || [];
              this.result_data.gene = res.data.data.gene || [];
            }
          })
          .catch((error) => {
            console.error("Error fetching data:", error);
          })
          .finally(() => {
            if (this._progressToken === token) {
              clearInterval(this.progressTimer);
              this.progressValue = 100;
            }
          });
    },

    async fetchAbundance() {
      this.abundanceLoaded = false;
      try {
        const res = await Axios.post(`${apiprefix}/api/detail_persite_tn/`, {}, {
          params: {
            select_id: this.currentId,
            select_type: this.currentType,
          },
        });

        if (res.data) {
          const { Phospho, RNA, Protein } = res.data;
          if (Phospho) {
            this.result_data.abundance.phos.metap = Phospho.metap?.toString() || null;
            this.result_data.abundance.phos.image = Phospho.image
                ? `data:${Phospho.image.type};base64,${Phospho.image.data}`
                : null;
          }
          if (RNA) {
            this.result_data.abundance.rna.metap = RNA.metap?.toString() || null;
            this.result_data.abundance.rna.image = RNA.image
                ? `data:${RNA.image.type};base64,${RNA.image.data}`
                : null;
          }
          if (Protein) {
            this.result_data.abundance.protein.metap = Protein.metap?.toString() || null;
            this.result_data.abundance.protein.image = Protein.image
                ? `data:${Protein.image.type};base64,${Protein.image.data}`
                : null;
          }
        }

        this.abundanceLoaded = true;

      } catch (error) {
        console.error("Error fetching abundance:", error);
        this.abundanceLoaded = false;
      }
    },

    fetchPhenotype() {
      return Axios.post(`${apiprefix}/api/detail_page_phenotype_per_site/`, {}, {
        params: {
          select_id: this.currentId,
          select_type: this.currentType,
        },
      })
          .then((res) => {
            if (res.data && res.data.data) {
              this.result_data.phenotype = {
                phenotype: res.data.data.phenotype || [],
                hallmark: res.data.data.hallmark || [],
                metap: res.data.data.metap || []
              };
            } else {
              console.warn("Unexpected response structure:", res.data);
            }
          })
          .catch((error) => {
            console.error("Error fetching phenotype:", error);
          });
    },
    loadData(tab) {
      this.selectedTab = tab;
    },

    // async loadData(tab) {
    //   this.selectedTab = tab;
    //
    //   if (!this.loadedTabs[tab]) {
    //     this.loadedTabs[tab] = true;
    //
    //     if (tab === 'cptac_phenotype' || tab === 'cptac_hallmark') {
    //       // await this.fetchPhenotype();
    //       this.loadedTabs['cptac_phenotype'] = true;
    //       this.loadedTabs['cptac_hallmark'] = true;
    //     } else {
    //       this.loadedTabs[tab] = true;
    //     }
    //     this.loadedTabs[tab] = false;
    //   }
    // },

    async reload() {
      this.loading = true;
      this.abundanceLoaded = false;
      this.selectedTab = 'basicInfo';

      try {
        await this.fetchInfo();
        await Promise.all([
          this.fetchAbundance(),
          this.fetchPhenotype()
        ]);
      } finally {
        this.loading = false;
      }
    }
  },

  computed: {
    breadcrumbData() {
      return [
        {text: "Home", disabled: false, to: "/"},
        {text: "Single Search", disabled: false, to: "/single-search"},
        {text: this.currentId, disabled: true}
      ];
    }
  },
  async beforeMount() {
    this.currentType = this.$route.query.ptm_type || this.ptm_type || "";
    this.currentId = this.$route.query.select_id || this.id;

    this.loading = true;
    this.progressValue = 0;

    try {
      await this.fetchInfo();
      await Promise.all([
        this.fetchAbundance(),
        this.fetchPhenotype()
      ]);
    } catch (e) {
      console.warn("Some data failed to load", e);
    } finally {
      this.loading = false;
    }
  },

  //  beforeMount() {
  //   this.currentType = this.$route.query.ptm_type || this.ptm_type || "";
  //   this.currentId = this.$route.query.select_id || this.id;
  //
  //   this.loading = true;
  //   this.progressValue = 0;
  //
  //   try {
  //      this.fetchInfo();
  //      Promise.all([
  //       this.fetchAbundance(),
  //       this.fetchPhenotype()
  //     ]);
  //   } catch (e) {
  //     console.warn("Some data failed to load", e);
  //   } finally {
  //     this.loading = false;
  //   }
  // },
  // beforeMount() {
  //   this.currentType = this.$route.query.ptm_type || this.ptm_type || "";
  //   this.currentId = this.$route.query.select_id || this.id;
  //
  //   this.loading = true;
  //   this.progressValue = 0;
  //
  //   this.fetchInfo()
  //       .then(() => Promise.all([this.fetchAbundance(), this.fetchPhenotype()]))
  //       .catch(err => console.warn("Some data failed to load", err));
  // },
  watch: {
    $route(to, from) {
      const newId = to.query.select_id || this.id;
      const newType = to.query.ptm_type || this.ptm_type || "";

      if (newId !== this.currentId || newType !== this.currentType) {
        this.currentId = newId;
        this.currentType = newType;
        this.reload();
      }
    },

    id(newVal) {
      if (newVal && newVal !== this.currentId) {
        this.currentId = newVal;
        this.reload();
      }
    }
  },
  beforeDestroy() {
    if (this.progressTimer) clearInterval(this.progressTimer);
    this._progressToken = null;
  }
};
</script>
